export const SET_BUSINESS = 'SET_BUSINESS'
export const SET_CHECKROLE = 'SET_CHECKROLE'
export const SET_ALLBUSINESS = 'SET_ALLBUSINESS'
export const SET_STATUS_BUSINESS = 'SET_STATUS_BUSINESS'
export const SET_DATA_CONSENT_ONECHAT = 'SET_DATA_CONSENT_ONECHAT'
export const SET_DATA_CONSENT_ONECHAT_PATH = 'SET_DATA_CONSENT_ONECHAT_PATH'
export const SET_DATA_GENERAL_DASHBOARD = 'SET_DATA_GENERAL_DASHBOARD'
export const SET_DATA_GROUP_DASHBOARD = 'SET_DATA_GROUP_DASHBOARD'
export const SET_ROLEACCOUNT = 'SET_ROLEACCOUNT'
export const SET_DATA_ACCOUNT = 'SET_DATA_ACCOUNT'
export const SET_DATA_BOT_ONEPLATFORM = 'SET_DATA_BOT_ONEPLATFORM'
export const SET_UPDATE_BOT = 'SET_UPDATE_BOT'

export const SET_DATAPOLICY = 'SET_DATAPOLICY'
export const SET_DATAPETITON = 'SET_DATAPETITON'
export const SET_DATACONSENT = 'SET_DATACONSENT'
export const SET_DATACONSENTID = 'SET_DATACONSENTID'
export const SET_DATA_SMTP_EMAIL = 'SET_DATA_SMTP_EMAIL'
export const SET_DATA_CONSENT_GROUP = 'SET_DATA_CONSENT_GROUP'
export const SET_DATA_GENERAL_CONSENT = 'SET_DATA_GENERAL_CONSENT'
export const SET_DATA_GROUP_CONSENT = 'SET_DATA_GROUP_CONSENT'

export const SET_MENU = 'SET_MENU'
export const GET_MENU_DEFAULT = 'GET_MENU_DEFAULT'
export const GET_ROLE_ACCESS = 'GET_ROLE_ACCESS'

export const SET_DATA_ANNOUNCE = 'SET_DATA_ANNOUNCE'
export const SET_DATA_GROUP_ONECHAT = 'SET_DATA_GROUP_ONECHAT'
export const SET_DATA_CHECK_USER = 'SET_DATA_CHECK_USER'

// เช็คการล็อกอิน
export const AUTH_PORTAL_CHECK = 'AUTH_PORTAL_CHECK'
export const AUTH_PORTAL_SUCCESS = 'AUTH_PORTAL_SUCCESS'
export const AUTH_PORTAL_EXPIRED = 'AUTH_PORTAL_EXPIRED'

// เช็คการล็อกอินเผื่อดึงข้อมูล
export const ACCOUNT_PORTAL_CHECK = 'ACCOUNT_PORTAL_CHECK'
export const ACCOUNT_PORTAL_SUCCESS = 'ACCOUNT_PORTAL_SUCCESS'
export const ACCOUNT_PORTAL_NOTFOUND = 'ACCOUNT_PORTAL_NOTFOUND'

export const SET_LOADING_LOGIN = 'SET_LOADING_LOGIN'
